<template>
<div>
    <div class="TTL-dialog">
        <el-dialog v-model="param.view" title="新增 / 编辑 / 查看病例" width="35%" :before-close="closeBefore">
            <el-form :model="form" align="center" v-loading="param.loading">
                <el-form-item label="家庭成员" label-width="80">
                    <div class="TTL-select select-out">
                        <el-select 
                        v-model="param.memberid" 
                        class="m-2" 
                        placeholder="请选择家庭成员" 
                        size="large" 
                        prefix-icon="User" 
                        clearable 
                        :disabled="param.isbindmemberid"
                        filterable>
                        <el-option
                            v-for="(item,index) in memberlists"
                            :key="index"
                            :label="item.name"
                            :value="item.id"
                            clearable
                        />
                        </el-select>
                        <div class="group-fresh">
                        <a class="TTL-fresh" @click="typefreshInit"></a>
                        </div>
                    </div>
                </el-form-item>
                <el-form-item label="病例类型" label-width="80">
                    <div class="TTL-select select-out">
                        <el-select 
                        v-model="param.type" 
                        class="m-2" 
                        placeholder="请选择病例类型" 
                        size="large" 
                        prefix-icon="User" 
                        clearable 
                        :disabled="param.isbindtype"
                        filterable>
                        <el-option
                            v-for="(item,index) in typelists"
                            :key="index"
                            :label="item.name"
                            :value="item.id"
                            clearable
                        />
                        </el-select>
                        <div class="group-fresh">
                        <a class="TTL-fresh" @click="memberfreshInit"></a>
                        </div>
                    </div>
                </el-form-item>
                <el-form-item label="就诊医院" label-width="80">
                    <div class="TTL-select select-out">
                        <el-select 
                        v-model="param.hospitalid" 
                        class="m-2" 
                        placeholder="请选择就诊医院" 
                        size="large" 
                        prefix-icon="User" 
                        clearable 
                        filterable>
                        <el-option
                            v-for="(item,index) in hospitallist"
                            :key="index"
                            :label="item.name"
                            :value="item.id"
                            clearable
                        />
                        </el-select>
                        <div class="group-fresh">
                        <a class="TTL-fresh" @click="hospitalfreshInit"></a>
                        <a class="TTL-fresh-edit" @click="lookhospital"></a>
                        </div>
                    </div>
                </el-form-item>
                <el-form-item label="就诊时间" label-width="80">
                <el-date-picker
                    v-model="param.inputtime"
                    type="date"
                    size="large"
                    placeholder="就诊时间"
                    value-format="YYYY-MM-DD"
                />
                </el-form-item>
                <el-form-item label="就诊金额" label-width="80">
                    <div class="TTL-select-money">
                    <el-input v-model="param.price" placeholder="就诊金额" round size="large">
                    <template #prepend>￥</template>
                    </el-input>
                    </div>
                </el-form-item>
            </el-form>

            <div>
                <div class="TTL-prennatal-info">
                    <el-button type="warning" size="large" round @click="addDetails">新增就诊详情</el-button>
                </div>
                <div class="TTL-prennatal-info-detail">
                <el-row class="TTL-prennatal-info-detail-main" v-for="(item,index) in param.detail">
                    <el-input type="textarea" v-model="item.content" placeholder="请填写就诊项目" round size="large"/>
                    <a class="TTL-prenatal-close" @click="delDetails(index)"></a>
                    <el-row class="TTL-prennatal-thumb">
                    <div class="TTL-PRENATAL-thumb thumb-default" @click="uploadthumbs(index)"></div>
                    <div class="TTL-PRENATAL-thumb" v-for="(thumbinfo,ii) in item.thumb">
                    <div class='TTL-PRENATAL-CLOSE'><el-button type="danger" size="small" circle icon="Close" @click="delthumbs(index,ii)" /></div>
                    <el-image 
                    :src="thumbinfo" 
                    :preview-src-list="[thumbinfo]" 
                    :initial-index="1"
                    preview-teleported="true"
                    :zoom-rate="1.2" 
                    fit="cover"  
                    />
                    </div>
                    </el-row>
                </el-row>


                </div>
            </div>
            <el-row>
                <div class="TTL-footer">
                    <el-button type="warning" size="large" round @click="savePrenatal">保存</el-button>
                    <el-button size="large" round @click="closeBefore">取消</el-button>
                </div>
            </el-row>
        </el-dialog>

        <!-- 自定义组件 -->
        <!-- 图片上传组件 -->
        <div><input type="file" id="PrenatallinfoAddorEdit" style="display:none;" multiple @change="getMyfiles" /></div>
        <!-- 医院地址信息 -->
        <div><Hospital :value="hospitalparam.view" @hospitalfinish="hospitalfinish" /></div>

    </div>
</div>
</template>
<script>
import INTERFACE_MODEL_BASE from '@/Interface/index';
import INTERFACE_MODEL_GENEALOGY from '@/Interface/Genealogy/home';
import Hospital from '@/views/Home/Module/Hospital.vue';
export default {
    props: ['id','value','memberid','type','hospitalid','isbindtype','isbindmemberid'],
    components:{Hospital},
    data() {
        return {
            param: {
                view:false,
                loading:false,
                id:'',
                memberid:'',
                type:'',
                isbindtype:false,
                isbindmemberid:false,
                content:'',
                hospitalid:'',
                address:'',
                price:'',
                inputtime:'',
                detail:[
                    {
                        id:1,
                        content:'唐氏筛查',
                        thumb:[
                            'http://api.home.com/Upload/middle/avar/20231009/83cfd0272917e2cf532caf6d0d2209d5.png',
                            'http://api.home.com/Upload/middle/avar/20231009/83cfd0272917e2cf532caf6d0d2209d5.png',
                            'http://api.home.com/Upload/middle/avar/20231009/83cfd0272917e2cf532caf6d0d2209d5.png',
                            'http://api.home.com/Upload/middle/avar/20231009/83cfd0272917e2cf532caf6d0d2209d5.png',
                            'http://api.home.com/Upload/middle/avar/20231009/83cfd0272917e2cf532caf6d0d2209d5.png',
                        ]
                    },
                ]
            },

            /** 病例类型 **/
            typelists:[],

            /** 家族成员 **/
            memberlists:[],

            /** 上传图片参数 **/
            thumbparam: {
                index:'',
                type:'prenatal',
                imagetype:'normal',
            },

            /** 就医地址信息 **/
            hospitallist:[],

            /** 查看医院组件信息 **/
            hospitalparam: {
                view:false,
            },

        }
    },

    watch: {
        value(val) {
            if(val) {
                this.param.view=true;
                this.param.id=this.id;
                this.param.memberid=this.memberid;
                this.param.type=this.type;
                this.param.isbindtype=this.isbindtype;
                this.param.isbindmemberid=this.isbindmemberid;
                this.param.hospitalid=this.hospitalid;
                this.paramreset(); //重置参数
                if(this.param.id > 0) this.getmemberprenatalinfos(); //获取会员问诊信息详情
                this.gettypelist(); //获取病例类型列表
                this.getAllmemberlist(); //获取家族成员信息列表
                this.getAllhospital(); //获取所有就医医院
            }
        },
    },

    methods: {

        /** 查看医院信息 **/
        lookhospital() {
            this.hospitalparam.view=true;
        },

        /** 保存病例信息 **/
        savePrenatal() {
            this.param.loading=true;
            this.param.details=JSON.stringify(this.param.detail);
            INTERFACE_MODEL_GENEALOGY.ADD_OR_EDIT_PRENATAL(this.param).then((res) => {
                this.param.loading=false;
                if(res.status > 0) return false;
                this.param.view=false;
                this.$emit('PrenatalInfoAddOrEditfinish');
            });
        },


        /** 上传就诊图片 **/
        uploadthumbs(index) {
            this.thumbparam.index=index;
            document.getElementById('PrenatallinfoAddorEdit').click();
        },


        /** 获取问诊图片 **/
        getMyfiles(e) {
            let _this=this;            
            for(var i=0; i < e.srcElement.files.length; i++) {
                //上传图片到接口操作
                INTERFACE_MODEL_BASE.UPLOAD_FILES({imageType:_this.thumbparam.imagetype,File:e.srcElement.files[i]}).then((res) => {
                    if(res.status > 0) return false;
                    let url=this.$ImageAddress+res.data.url;
                    _this.param.detail[this.thumbparam.index].thumb.push(url);
                });
            }

            e.srcElement.value=''; //清空数据
        },


        /** 新增就诊详情 **/
        addDetails() {
            this.param.detail.push({id:'',content:'',thumb:[]});
        },


        /** 删除就诊项目 **/
        delDetails(index) {
            this.param.detail.splice(index,1);
        },


        /** 删除就诊项目图片 **/
        delthumbs(index,ii) {
            this.param.detail[index].thumb.splice(ii,1);
        },


        /** 关闭窗口回调信息 **/
        closeBefore() {
            this.param.view=false;
            this.$emit('PrenatalInfoAddOrEditfinish');
        },

        /** 获取会员问诊信息详情 **/
        getmemberprenatalinfos() {
            this.param.loading=true;
            INTERFACE_MODEL_GENEALOGY.GET_MEMBER_PRENATALINFO_DETAILS(this.param).then((res) => {
                this.param.loading=false;
                if(res.status > 0) return false;
                console.log(res.data);

                let data=res.data;
                this.param.id=data.id;
                this.param.memberid=data.memberid;
                this.param.type=data.type;
                this.param.content=data.content;
                this.param.address=data.address;
                this.param.price=data.price;
                this.param.inputtime=data.inputtime;
                this.param.detail=data.details;
            });
        },

        
        /** 刷新初始化数据 **/
        typefreshInit() {
            var load=this.$loading.service(this.$loadingparam); //加载loading动画
            this.gettypelist();
            load.close(); //关闭loading动画
        },


        /** 刷洗初始化会员数据 **/
        memberfreshInit() {
            var load=this.$loading.service(this.$loadingparam); //加载loading动画
            this.getAllmemberlist();
            load.close(); //关闭loading动画
        },
        

        /** 刷新初始化医院数据 **/
        hospitalfreshInit() {
            var load=this.$loading.service(this.$loadingparam); //加载loading动画
            this.getAllhospital();
            load.close(); //关闭loading动画
        },


        /** 获取病例类型 **/
        gettypelist() {
            this.typelists=[];
            INTERFACE_MODEL_GENEALOGY.GET_MEMBER_PRENATALINFO_TYPE({}).then((res) => {
                if(res.status > 0) return false;
                this.typelists=res.data;
            });
        },


        /** 获取家庭成员列表 **/
        getAllmemberlist() {
            this.memberlists=[];
            INTERFACE_MODEL_GENEALOGY.GET_ALL_HOME_MEMBER({}).then((res) => {
                if(res.status > 0) return false;
                this.memberlists=res.data;
            });
        },


        /** 获取就医医院 **/
        getAllhospital() {
            this.hospitallist=[];
            INTERFACE_MODEL_GENEALOGY.GET_ALL_HOSPITAL({}).then((res) => {
                if(res.status > 0) return false;
                this.hospitallist=res.data;
            });
        },

        
        /** 处理医院信息完成回调 **/
        hospitalfinish() {
            this.hospitalparam.view=false;
            this.getAllhospital();
        },


        /** 重置提交参数 **/
        paramreset() {
            this.param.content='';
            this.param.address='';
            this.param.price='';
            this.param.inputtime='';
            this.param.detail=[];
        },

    },

}
</script>
<style scoped>
.TTL-prennatal-info {margin-top:40px;}
.TTL-prennatal-info-detail {display:inline-block;width:100%;margin-top:20px;}
.TTL-prennatal-info-detail .el-row {display:flex;align-items:center;}
.TTL-prennatal-thumb {border-top:1px dashed #E6E8EB;width:100%;display:flex;justify-content:left;padding:20px 0;margin-top:20px;}
.TTL-PRENATAL-thumb {width:80px;height:80px;border-radius:6px;border:1px solid #E4E7ED;margin:0 15px 15px 0;Position:relative;}
.TTL-PRENATAL-thumb .el-image {overflow:hidden;width:80px;height:80px;border-radius:6px;}
.thumb-default {cursor:pointer;display:inline-block;background:url(@/assets/icon/plus-add.png) no-repeat;background-size:25px;background-Position:center;}
.TTL-PRENATAL-CLOSE {width:20px;height:20px;border-radius:50%;Position:absolute;right:0;top:0;margin-right:-10px;margin-top:-10px;z-index:10;display:flex;justify-content:center;align-items:center;}
.TTL-prennatal-info-detail-main {width:calc(100% - 20px);border-radius:6px;border:1px solid #CDD0D6;padding:10px;margin-bottom:10px;}
:deep(.TTL-prennatal-info-detail-main .el-textarea__inner) {box-shadow: none !important;}
.TTL-prenatal-close {width:25px;height:25px;cursor:pointer;Position:absolute;right:0;top:0;border-radius:0 0 0 25px;background:#F56C6C url(@/assets/icon/close.png) no-repeat;background-size:8px;background-Position:11px 8px;}
</style>